<template>
    <div class="_upload">
    </div>
</template>
 
 
<script>
  import jquery from '../../utils/jquery';
//   const WebUploader = require('./webuploader.js')
import {webuploader} from './webuploader.js'
//   import * as WebUploader from './webuploader.js'
  import swgimg from './Uploader.swf';
 
  export default {
    props: {
      // 上传按钮ID
      upload_button: {
        type: String,
        default: '._upload'
      },
      // 上传地址
      cdnUrl: {
        type: String,
        default: ''
      },
      // 上传最大数量 默认为100
      fileNumLimit: {
        type: Number,
        default: 1
      },
      // 大小限制 默认20M
      fileSingleSizeLimit: {
        type: Number,
        default: 20971520
      },
      //上传token等参数
      formData: {
        type: Object,
        default: null
      },
      imageUrl: {
        type: String,
        default: ''
      },
      accept: {
        type: Object,
        default: null
      },
      headers: {
      	type: Object,
        default: null
      },
      keyGenerator: {
        type: Function,
        default: function (file) {
          const currentTime = new Date().getTime();
          const key = currentTime + "." + file.name;
          return key;
        }
      },
      //上传之前的正则
      uploadFlag:{
      	type: Object,
        default: null
      },
      //是否自动上传
      auto:{
      	type: Boolean,
        default: true
      }
    },
    data() {
      return {
      	uploader: null,
      };
    },
    mounted() {
      this.initWebUpload();
    },
    methods: {
    	toUpload(form){
    		let self = this;
    		self.uploader.option('formData',form)
    		
    		self.uploader.upload();
    	},
      initWebUpload() {
        var self = this;
        self.uploader = WebUploader.create({
          auto: self.auto, // 选完文件后，是否自动上传
          swf: swgimg, // swf文件路径
          server: self.cdnUrl,  // 文件接收服务端
          timeout: 3 * 60 * 1000,//超时时间
          pick: {
            id: self.upload_button,
            multiple:false,
            label: ''
          }, // 选择文件的按钮。可选
 		  headers:self.headers,
          // 允许选择文件格式。
          accept: self.accept,
          thread: 1,
          fileNumLimit: self.fileNumLimit, //限制上传个数
          fileSingleSizeLimit: self.fileSingleSizeLimit, //限制单个上传图片的大小
          formData: self.formData,  //上传七牛所需参数
          duplicate: true  //重复上传
        });
        //当文件被加入到队列之前
	       self.uploader.on( 'beforeFileQueued', function( file ) {
//	       	let res = self.uploadFlag.reg;
//		   	if(!res.test(file.name)){
//		         self.$emit('beforeList', file);
//		         return false;
//		     }
				self.uploader.reset();//清空之前的队列
	       });
        // 当有文件被添加进队列的时候，添加到页面预览
           self.uploader.on( 'fileQueued', function( file ) {
//           self.uploader.options.formData.key = self.keyGenerator(file);
             self.$emit('before', file);
           });
        // 文件上传过程中创建进度条实时显示。
        self.uploader.on( 'uploadProgress', function( file, percentage ) {
          self.$emit('progress', file, percentage);
        });
        self.uploader.on( 'uploadSuccess', function( file, response ) {
          self.$emit('success', file, response);
          self.uploader.removeFile(file);
        });
 
        self.uploader.on( 'error', function( type ) {
          let errorMessage = '';
          if (type == "F_EXCEED_SIZE") {
            errorMessage = "文件大小不能超过" + self.fileSingleSizeLimit/(1024*1024) + "M";
          } else if (type == "Q_EXCEED_NUM_LIMIT") {
            errorMessage = '文件上传已达到最大上限数';
          } else if (type == "Q_TYPE_DENIED"){
          	errorMessage = "文件为空！";
          }else {
            errorMessage = "上传出错！请检查后重新上传！错误代码" + type;
          }
          self.$emit('error', errorMessage);
        });
 
        self.uploader.on( 'uploadComplete', function( file, response ) {
          self.$emit('complete', file, response);
        });
        self.uploader.on( 'uploadError', function( file, response ) {
          self.$emit('errorserver', file, response);
        });
      },
    }
  }
</script>
 
<style>
  .webuploader-container {
    position: relative;
    text-align: left;
  }
  .webuploader-element-invisible {
    position: absolute !important;
    clip: rect(1px 1px 1px 1px); /* IE6, IE7 */
    clip: rect(1px,1px,1px,1px);
  }
  .webuploader-pick {
    position: relative;
    display: inline-block;
    cursor: pointer;
    background: #edf6fa;
    padding: 0 10px 0 24px;
    color: #333333;
    text-align: center;
    border-radius: 3px;
    border: solid 1px #c1daf8;
    /*overflow: hidden;*/
  }
  .webuploader-pick-hover {
    background: #edf6fa;
  }
 
  .webuploader-pick-disable {
    opacity: 0.6;
    pointer-events:none;
  }
</style>


// WEBPACK FOOTER //
// src/common/plugin/webupload/index.vue